import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unitConversion',
})
export class UnitConversionPipe implements PipeTransform {
    private conversionFactors = {
        inchesToCentimeters: 2.54,
        centimetersToInches: 0.393701,
        kilogramsToPounds: 2.20462,
        poundsToKilograms: 0.453592,
        mphToKmh: 1.60934,
        kmhToMph: 0.621371,
    };

    constructor() {}

    transform(input: string): string {
        // Updated regex to handle degree symbol and multi-character units
        const regex = /(\d+(\.\d+)?)\s*([°]?\w+\/?\w*)/;
        const match = input.match(regex);

        if (!match || !match[1] || !match[3]) {
            return 'Invalid input';
        }

        const value = parseFloat(match[1]);
        const unit = match[3].toLowerCase();

        if (value == null || Number.isNaN(value)) {
            return 'Invalid value';
        }

        let convertedValue: number;
        let resultUnit: string;
        const isImperial = navigator.language.includes('US');

        switch (unit) {
            case 'in':
                if (isImperial) {
                    return input;
                }
                resultUnit = ' cm';
                convertedValue = value * this.conversionFactors.inchesToCentimeters;
                break;
            case 'cm':
                if (!isImperial) {
                    return input;
                }
                resultUnit = ' in';
                convertedValue = value * this.conversionFactors.centimetersToInches;
                break;
            case 'kg':
                if (!isImperial) {
                    return input;
                }
                resultUnit = ' lb';
                convertedValue = value * this.conversionFactors.kilogramsToPounds;
                break;
            case 'lb':
                if (isImperial) {
                    return input;
                }
                resultUnit = ' kg';
                convertedValue = value * this.conversionFactors.poundsToKilograms;
                break;
            case '°f':
            case 'f':
                if (isImperial) {
                    return input;
                }
                resultUnit = '°C';
                // Fahrenheit to Celsius: (°F - 32) × 5/9
                convertedValue = (value - 32) * 5 / 9;
                break;
            case '°c':
            case 'c':
                if (!isImperial) {
                    return input;
                }
                resultUnit = '°F';
                // Celsius to Fahrenheit: (°C × 9/5) + 32
                convertedValue = (value * 9 / 5) + 32;
                break;
            case 'mph':
                if (isImperial) {
                    return input;
                }
                resultUnit = ' km/h';
                convertedValue = value * this.conversionFactors.mphToKmh;
                break;
            case 'km/h':
            case 'kmh':
            case 'kph':
                if (!isImperial) {
                    return input;
                }
                resultUnit = ' mph';
                convertedValue = value * this.conversionFactors.kmhToMph;
                break;
            default:
                return 'Invalid unit';
        }

        return `${convertedValue.toFixed(2)}${resultUnit}`;
    }
}
